import _ from 'lodash';

/**
 * @type {Object} EVENT_NAMES
 */
export const EVENT_NAMES = {
  BRZW_CALENDAR_DATE_CHANGE: 'brzwCalendarDateChange',
};

/**
 * @type {Function}
 */
export class BrzwEvent {
  /**
   * @param {String} eventName
   */
  constructor(eventName) {
    /**
     * @type {String}
     */
    this.eventName = eventName || '';

    // Bindings
    this.dispatchEvent = this.dispatchEvent.bind(this);
    this.listenEvent = this.listenEvent.bind(this);
    this.removeEvent = this.removeEvent.bind(this);
    this.isSupplied = this.isSupplied.bind(this);
  }

  /**
   * @param {Object} params
   * @param {Object} opt
   */
  dispatchEvent(params = {}, opt = {}) {
    if (this.isSupplied()) {
      const eventToDispatch = new CustomEvent(this.eventName, {
        bubbles: true,
        cancelable: true,
        detail: params,
        ...opt,
      });

      document.dispatchEvent(eventToDispatch);
    }
  }

  /**
   * @param {Function} callback
   */
  listenEvent(callback) {
    if (this.isSupplied()) {
      document.addEventListener(this.eventName, callback);
    }
  }

  /**
   * @param {Function} callback
   */
  removeEvent(callback) {
    if (this.isSupplied()) {
      document.removeEventListener(this.eventName, callback);
    }
  }

  /**
   * @return {Boolean}
   */
  isSupplied() {
    const isCorrectName = _.includes(_.values(EVENT_NAMES), this.eventName);

    return document && isCorrectName;
  }
}
